import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Gallery from "../pages/gallery/page";
import MaklerService from "../pages/makler-service/page";
import UeberUns from "../pages/ueber-uns/page";
import Kontakt from "../pages/kontakt/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";
import Agb from "../pages/agb/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/makler-service",
    element: <MaklerService />,
  },
  {
    path: "/ueber-uns",
    element: <UeberUns />,
  },
  {
    path: "/kontakt",
    element: <Kontakt />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "/agb",
    element: <Agb />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
